import { use } from 'react';
import { ForsideteksterContext } from './forsideteksterContext';

export function useForsideteksterContext() {
  return use(ForsideteksterContext)!;
}
